import ProjectService from '@/services/project';

const fetchKeyplans = async ({ commit, rootState }) => {
  const res = await ProjectService.fetchKPData(rootState.project.adhocId);
  const keyplanList = [];
  Object.values(res.data).forEach((keyplan) => {
    keyplanList.push(keyplan);
  });
  commit('setKeyplanList', keyplanList);
};

export default {
  fetchKeyplans
};



// WEBPACK FOOTER //
// ./src/store/modules/floorplans/availability/actions.js